import React from 'react';

import { FaCheck } from 'react-icons/fa';

import { Container } from './styles';

import { LabelProps } from './interface';

const Label: React.FC<LabelProps> = ({ number, label, subtitle, status }) => {
  return (
    <Container status={status}>
      <div>
        <small>
          {label}
          <i>
            {status ? (
              <i>
                <FaCheck size={22} color={status ? '#666' : '#222'} />
              </i>
            ) : null}
          </i>
        </small>
        <p>{subtitle}</p>
      </div>
    </Container>
  );
};

export default Label;
